export const GET_PROJAPOLLO_RUNS_DATA='GET_PROJAPOLLO_RUNS_DATA';
export const GET_PROJAPOLLO_RUNS_DATA_ERROR='GET_PROJAPOLLO_RUNS_DATA_ERROR';
export const GET_PROJAPOLLO_HDR_DATASETS_DATA='GET_PROJAPOLLO_HDR_DATASETS_DATA';
export const GET_PROJAPOLLO_HDR_DATASETS_DATA_ERROR='GET_PROJAPOLLO_HDR_DATASETS_DATA_ERROR';
export const GET_PROJAPOLLO_ITEM_DATASETS_DATA='GET_PROJAPOLLO_ITEM_DATASETS_DATA';
export const GET_PROJAPOLLO_ITEM_DATASETS_DATA_ERROR='GET_PROJAPOLLO_ITEM_DATASETS_DATA_ERROR';
export const GET_PROJAPOLLO_XMLS_DATA='GET_PROJAPOLLO_XMLS_DATA';
export const GET_PROJAPOLLO_XMLS_DATA_ERROR='GET_PROJAPOLLO_XMLS_DATA_ERROR';


// WEBPACK FOOTER //
// ./src/redux/projApollo/actionTypes.js